import { DropdownOption } from '@ravago/shared/radiance/components/input-field/components/Dropdown/Dropdown';
import { PhoneDetails } from '@ravago/shared/radiance/components/input-field/components/PhoneInputField/PhoneInputField.types';

export interface UserRegistrationRequest {
  firstName: string;
  lastName: string;
  email: string;
  language: string;
  company: CompanyInfo;
  visit?: Visit;
}

export interface CompanyInfo {
  name: string;
  countryIsoCode: string;
  phoneNumber: string;
}

export interface Visit {
  visitorId: string;
  utm: Utm;
}

export interface Utm {
  source: string;
  medium: string;
  campaign: string;
  content: string;
}

export interface EmailFormValue {
  email: string;
}

export interface AccountInformationFormValue {
  firstName: string;
  lastName: string;
  companyName: string;
  country: DropdownOption;
  phone: PhoneDetails;
  acceptTermsAndConditions: boolean;
}

export enum RegistrationStep {
  EMAIL_ADDRESS = 'auth.email-address-title',
  ACCOUNT_INFO = 'auth.account-info-title',
  CONFIRM_REGISTRATION = 'confirm-registration'
}
